import React, { useEffect, useState, useMemo } from 'react';
import { ParticleConfig } from '../seasonConfig';
import './Particles.css';

interface ParticleEffectProps {
    config: ParticleConfig;
    duration?: number; // Duration in seconds before fading out (0 = infinite)
}

interface ParticleStyle {
    left: string;
    animationDuration: string;
    animationDelay: string;
    opacity: number;
    fontSize: string;
    color?: string;
}

const ParticleEffect: React.FC<ParticleEffectProps> = ({ config, duration = 0 }) => {
    const [visible, setVisible] = useState(true);
    const [fading, setFading] = useState(false);

    useEffect(() => {
        if (duration > 0) {
            const fadeTimer = setTimeout(() => {
                setFading(true);
            }, duration * 1000);

            const hideTimer = setTimeout(() => {
                setVisible(false);
            }, (duration + 2) * 1000);

            return () => {
                clearTimeout(fadeTimer);
                clearTimeout(hideTimer);
            };
        }
    }, [duration]);

    // Generate particle styles once
    const particleStyles = useMemo(() => {
        return [...Array(config.count)].map((_, i) => {
            const style: ParticleStyle = {
                left: `${Math.random() * 100}%`,
                animationDuration: `${4 + Math.random() * 6}s`,
                animationDelay: `${Math.random() * 5}s`,
                opacity: 0.5 + Math.random() * 0.5,
                fontSize: `${10 + Math.random() * 14}px`,
            };

            if (config.colors && config.colors.length > 0) {
                style.color = config.colors[Math.floor(Math.random() * config.colors.length)];
            }

            return style;
        });
    }, [config.count, config.colors]);

    if (!visible) return null;

    const rotationClass = `particle--rotation-${config.rotationSpeed || 'none'}`;

    return (
        <div className={`particles-container ${fading ? 'particles-container--fading' : ''}`}>
            {particleStyles.map((style, i) => (
                <div
                    key={i}
                    className={`particle ${rotationClass}`}
                    style={style}
                >
                    {config.symbol}
                </div>
            ))}
        </div>
    );
};

export default ParticleEffect;
